/**
 * Format a Date object as YYYY-MM-DD using local timezone.
 * Avoids the classic bug where toISOString().split('T')[0] shifts
 * the date backwards for timezones ahead of UTC.
 */
export function formatLocalDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
